import { createContext } from 'react';

/**
 * Contexto por INSTANCIA del panel de navegación (sidebar desktop / drawer mobile).
 *
 * - iconOnly: rail colapsado (solo íconos). Antes cada menú leía `miniDrawer` de redux;
 *   ahora lo decide el host (desktop = miniDrawer, mobile = siempre expandido).
 * - query: filtro del buscador del sidebar (quick-jump sobre los ítems del rol).
 * - onNavigate: hook del host al navegar (mobile cierra el drawer, limpia el filtro).
 * - isMobile: el panel vive dentro del drawer deslizante. El ítem lo usa para CERRAR ANTES de
 *   navegar; si navega a la vez, el render de la pantalla nueva compite con la animación de
 *   cierre y el panel se queda a medio recoger encima del contenido.
 * - registerItem/unregisterItem: registro de ítems visibles para el salto con Enter.
 */
const SidebarPanelContext = createContext({
  iconOnly: false,
  isMobile: false,
  query: '',
  onNavigate: () => {},
  registerItem: () => {},
  unregisterItem: () => {}
});

/** Normaliza texto para búsqueda: minúsculas y sin acentos. */
export const normalizeSearchText = (text = '') =>
  String(text)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

/** true si `label` matchea el filtro `query` (insensible a mayúsculas/acentos). */
export const matchesSearchQuery = (label, query) => {
  const normalizedQuery = normalizeSearchText(query);
  if (!normalizedQuery) return true;
  return normalizeSearchText(label).includes(normalizedQuery);
};

export default SidebarPanelContext;
